import { render, staticRenderFns } from "./ContratacaoDetalhesCardDadosPreco.vue?vue&type=template&id=69ef0147"
import script from "./ContratacaoDetalhesCardDadosPreco.vue?vue&type=script&lang=js"
export * from "./ContratacaoDetalhesCardDadosPreco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports